import React from "react";
import { Navigate } from "react-router";
import { NavLink } from "react-router-dom";
import Base from "./Base";
import { Header } from "./Header";
import { Footer } from "./Footer";
import Meeting from "./Meeting";
import MeetingResults from "./MeetingResults";
import SelectAsync from 'react-select/async';

export default class Meetings extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.companyResumeId,
            inline: this.isNull(props.Inline) ? false : props.Inline,
            controllerName: "meeting",
            data: null,
            loading: true,
            page: 1,
            per_page: 30,
            phrase: '',
            filters: {
                personId: this.isNull(props.PersonId) ? this.getDefaultGuid() : props.PersonId,
                personName: '',
                forMe: props.ForMe,
                meetingResultId: this.getDefaultGuid(),
                meetingStatus: 0
            },
            systemModuleId: 28,
            moduleAccessStatus: 1,
            menuId: 82
        };
        if (this.state.filters.forMe) this.state.menuId = 81;
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.refreshData();
            });
    }
    componentWillReceiveProps(props) {
        if (props.ForMe == this.state.filters.forMe) return;

        this.state.filters.forMe = props.ForMe;
        if (this.state.filters.forMe) this.state.menuId = 81;

        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.refreshData();
            });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({
            component: (
                <Meeting
                    ReadOnly={false}
                    Caller={this}
                    previousMeetingId={this.defaultGuid()}
                />
            ),
        });
    }
    onPreviousAdd(id) {
        this.removeKeyDown();
        this.showComponents({
            component: (
                <Meeting
                    ReadOnly={false}
                    Caller={this}
                    previousMeetingId={id}
                />
            ),
        });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({
            component: (
                <Meeting
                    ReadOnly={this.state.filters.forMe}
                    Caller={this}
                    Id={id}
                    previousMeetingId={this.defaultGuid()}
                />
            ),
        });
    }
    onResults() {
        this.removeKeyDown();
        this.showComponents({
            component: (
                <MeetingResults
                    Caller={this}
                />
            ),
        });
    }
    
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);
        
        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            {this.state.filters.forMe && <h3 className="nk-block-title page-title">فهرست جلسات من</h3>}
                            {!this.state.filters.forMe && <h3 className="nk-block-title page-title">فهرست جلسات</h3>}
                            <div className="nk-block-des text-soft">
                                <p>{this.money(this.state.data.recordsCount)} جلسه یافت شد</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        {!this.state.filters.forMe && <li>
                                            <a className="hand btn btn-primary" onClick={e => this.onAdd()}><span className="shortcut">F2 - </span><span>ایجاد جلسه جدید</span></a>
                                        </li>}
                                        <li>
                                            <a onClick={e => this.onResults()} className="hand btn btn-warning">نتایج</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.renderView()}
            </div>
        </div>
    }
    renderView() {
        return <div className="nk-block">
            <div className="card card-bordered card-stretch">
                <div className="card-inner-group">
                    <div className="card-inner position-relative card-tools-toggle">
                        <div className="card-title-group">
                            <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                <div className="form-inline flex-nowrap gx-3">
                                    <div className="form-wrap">
                                        <input
                                            type="text"
                                            defaultValue={this.state.phrase}
                                            onChange={(e) => this.state.phrase = e.target.value}
                                            placeholder="موضوع جلسه"
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="form-wrap">
                                        <input
                                            type="text"
                                            defaultValue={this.state.filters.personName}
                                            onChange={(e) => this.state.filters.personName = e.target.value}
                                            placeholder="نام شخص"
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="form-wrap">
                                        <select
                                            type="text"
                                            defaultValue={this.state.filters.meetingStatus}
                                            onChange={(e) =>this.state.filters.meetingStatus = parseInt(e.target.value)}
                                            className="form-control">
                                            <option value="1">باز</option>
                                            <option value="2">برگزار شده</option>
                                            <option value="3">کنسل شده</option>
                                            <option value="4">عدم حضور</option>
                                            <option value="5">بسته شد</option>
                                        </select>
                                    </div>
                                    <div className="form-wrap">
                                        <SelectAsync
                                            isClearable={true}
                                            style={{ width: "100%" }}
                                            isMulti={false}
                                            placeholder="همه نتایج"
                                            defaultOptions
                                            loadOptions={(inputValue, callback) => this.loadMeetingResualtOptions(inputValue, callback, 0)}
                                            onChange={(e) =>
                                                this.isNull(e) ? this.state.filters.meetingResultId = this.getDefaultGuid() :
                                                    this.state.filters.meetingResultId = e.value
                                            }
                                        />
                                    </div>
                                    <div className="btn-wrap">
                                        <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    {this.state.data.recordsCount <= 0 ?
                        <div className="card-inner-group">
                            <div className="example-alert">
                                <div className="alert alert-pro alert-warning">
                                    <div className="alert-text">
                                        <h6>توجه</h6>
                                        <p>هیچ جلسه ای یافت نشد</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="card-inner p-0">
                            <div className="nk-tb-list nk-tb-ulist">
                                <div className="nk-tb-item nk-tb-head">
                                    <div className="nk-tb-col text-center"><span className="sub-text">موضوع</span></div>
                                    <div className="nk-tb-col text-center"><span className="sub-text">تاریخ برگزاری</span></div>
                                    <div className="nk-tb-col text-center"><span className="sub-text">ساعت</span></div>
                                    <div className="nk-tb-col text-center"><span className="sub-text">نحوه برگزاری</span></div>
                                    <div className="nk-tb-col text-center"><span className="sub-text">اعضای</span></div>
                                    <div className="nk-tb-col text-center"><span className="sub-text">مدیران</span></div>
                                    <div className="nk-tb-col text-center"><span className="sub-text">محل برگزاری</span></div>
                                    <div className="nk-tb-col text-center"><span className="sub-text">وضعیت جلسه</span></div>
                                    <div className="nk-tb-col text-center"><span className="sub-text">نتیجه</span></div>
                                    {!this.state.filters.forMe && <div className="nk-tb-col text-end"><span className="sub-text">عملیات</span></div>}
                                </div>
                                {this.state.data.records.map((record, index) =>
                                    <div className="nk-tb-item">
                                        <div className="nk-tb-col">
                                            <span className="sub-text text-center text-succe">{record.subject}</span>
                                        </div>
                                        <div className="nk-tb-col">
                                            <span className="sub-text text-center">
                                                <a className="text-primary txt-bold hand" onClick={e => this.onEdit(record.id)} title="مشاهده و ویرایش">
                                                    {record.dateString}
                                                </a>
                                            </span>
                                        </div>
                                        <div className="nk-tb-col">
                                            <span className="sub-text text-center text-succe">{record.timeFormated}</span>
                                        </div>
                                        <div className="nk-tb-col">
                                            <span className="sub-text text-center text-succe">{record.typeString}</span>
                                        </div>
                                        <div className="nk-tb-col">
                                        {record.members.map(f =>
                                            <span style={{ "background-color": "#dbdfea", "padding": "0 5px", "margin-left": "5px", "border-radius": "5px", "margin-bottom": "15px", "display": "inline-block" }}>{f.label}</span>
                                            )}
                                        </div>
                                        <div className="nk-tb-col">
                                            {record.managers.map(f =>
                                                <span style={{ "background-color": "#dbdfea", "padding": "0 5px", "margin-left": "5px", "border-radius": "5px", "margin-bottom": "15px", "display": "inline-block" }}>{f.label}</span>
                                            )}
                                        </div>
                                        <div className="nk-tb-col">
                                            <span className="sub-text text-center">{record.address}</span>
                                        </div>
                                        <div className="nk-tb-col text-center">
                                            <span className={"text-center " + (record.meetingStatus === 2 ? "text-success" : record.meetingStatus === 4 ? "text-danger" : "text-info")}>{record.meetingStatusString}</span>
                                        </div>
                                        <div className="nk-tb-col text-center">
                                            <span className="text-center text-info">{record.meetingResultString}</span>
                                        </div>                                        
                                        {!this.state.filters.forMe && <div className="nk-tb-col text-end">
                                            <a className="hand text-danger mx-1" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف">
                                                <em className="icon ni ni-cross-fill-c"></em>
                                            </a>
                                            <a className="hand text-primary mx-1" onClick={e => this.onEdit(record.id)} title="ویرایش">
                                                <em className="icon ni ni-pen"></em>
                                            </a>
                                            <a
                                                className="hand text-primary mx-1"
                                                onClick={(e) => this.onPreviousAdd(record.id)}
                                                title="جلسه بعد"
                                            >
                                                <em className="icon ni ni-plus"></em>
                                            </a>
                                        </div>}
                                    </div>
                                )}
                            </div>
                        </div>
                    }
                    {this.createPaging()}
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect))
            return <Navigate to={this.state.redirect} />;

        let contents = this.state.loading
            ? this.renderLoading()
            : [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.isEmpty(this.state.data.global.companies) ? [
                    <Header data={this.state.data} />,
                    <div className="nk-content ">
                        <div className="container-fluid">
                            <div className="nk-content-inner">
                                {this.renderNoCompanyRegister()}
                            </div>
                        </div>
                    </div>,
                ] :
                    this.state.inline ? this.renderView() :
                        [
                    <Header data={this.state.data} />,
                            <div className="nk-content ">
                                <div className="container-fluid">
                                    <div className="nk-content-inner">
                                        {this.renderForm()}
                                    </div>
                                </div>
                            </div>,
                    <Footer />,
                        ]
                ,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}